import { Component, OnInit, ViewEncapsulation, Output, EventEmitter, SimpleChanges, Input } from '@angular/core';
import { SigninService } from '../../../services/signin.service';
import uuid from 'uuid';
import { AlertService } from '../../../providers/alert.service';
import { SysconfigService } from '../../../services/sysconfig.service';
export interface NeedSecurityCodeModel {
  BackImage: string;
  needSecurityCode: boolean;
  SlidingImage: string;
  yHeight: number;
}
@Component({
  selector: 'app-slider-verification',
  template: require('./slider-verification.component.html'),
  styles: [require('./slider-verification.component.scss')],
  providers: [AlertService, SysconfigService],
  encapsulation: ViewEncapsulation.None
})

export class SliderVerificationComponent implements OnInit {


  @Output() onSliderValidate = new EventEmitter();

  @Output() Close = new EventEmitter();
  @Input('username') username;
  /** 刷新登录页验证滑块 */
  @Input('refresh') date: any;
  @Input('needCaptail') needCaptail: any;

  /** 刷新登录页验证滑块 */
  @Input('refreshTwo') dateTwo: any;

  //#region  参数声明 

  showCaptail: boolean = false;

  /**
   * 初始化是否需要验证码
   */
  needSecurityCodeModel: NeedSecurityCodeModel;

  // 图片前缀
  imgPrefix: string = `data:image/png;base64`;

  // 滑块验证背景图片
  validateBackgroundImage: string = '';

  // 滑块验证滑块图片
  validateSliderImage: string = '';

  /**
   * 设置滑块图片水平位移距离
   */
  horizontalDisplacement: number = 0;

  /**
   * 设置滑块图片垂直高度
   */
  verticalHeight: number = 0;

  // 设置滑块图片的水平位移和垂直位移
  imgStyle: string = '';

  /** 是否登录页 */
  isLogin = null;

  //#endregion
  catchId = uuid();
  loading: boolean = false;
  constructor(
    private login: SigninService,
    private alert: AlertService,
    private sysConfig: SysconfigService
  ) { }

  ngOnInit(): void {

  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.needCaptail.currentValue) {
      this.needSecurityCode();
    }


    if (changes.date && !changes.firstChange) {
      this.needSecurityCode();
      this.isLogin = true;
    }
  }

  /** 点击刷新 */
  refresh() {
    this.needSecurityCode();
  }

  /**
   * 滑块验证图片
   */
  needSecurityCode() {
    this.sysConfig.getSecurityCode(this.catchId).then((res) => {
      if (res) {
        this.needSecurityCodeModel = res;
        // this.showCaptail = this.needSecurityCodeModel.needSecurityCode;
        if (this.needSecurityCodeModel.BackImage
          && this.needSecurityCodeModel.SlidingImage
          && this.needSecurityCodeModel.yHeight) {
          this.validateBackgroundImage = `${this.imgPrefix},${this.needSecurityCodeModel.BackImage}`;
          this.validateSliderImage = `${this.imgPrefix},${this.needSecurityCodeModel.SlidingImage}`;
          this.verticalHeight = this.needSecurityCodeModel.yHeight;
        }
      }
    })
  }


  /**
   * 滑块值改变时间 
   */
  sliderModelChange($event: number) {
    this.horizontalDisplacement = $event;
  }

  /**
   * 
   */
  sliderAfterChange($event: number) {
    this.showCaptail = false;
    this.authSecurityCode($event)
    this.horizontalDisplacement = 0;
  }

  /** 验证验证码是否正确 */
  authSecurityCode(even) {
    this.loading = true;
    let params = { Xpos: even, Ypos: this.verticalHeight, CatchId: this.catchId }
    this.sysConfig.authSecurityCode(params).then((res) => {
      this.loading = false;
      if (res.Result) {
        this.onSliderValidate.emit(this.catchId);

      } else {
        this.alert.errorAlert('验证失败，请再次验证')
      }
    },
      (err) => { this.loading = false; }
    );
  }

  CloseModal() {
    this.Close.emit(true);
  }
}



// WEBPACK FOOTER //
// node_modules/ngc-webpack??ref--0-3!./node_modules/angular2-template-loader!./node_modules/tslint-loader??ref--7-0!./src/app/login/slider-verification/slider-verification.component.ts